import React from 'react';
import classes from './CenterContainer.css';

export const CenterContainer = ({ children }) => (
    <div className={classes.Container}>
        {children}
    </div>
)


// WEBPACK FOOTER //
// ./src/components/CenterContainer/CenterContainer.js